export enum CreateRequirementDefinitionSharedFileMimeType {
  Image = "image",
  Document = "document",
  Other = "other"
}
